

export const Daily=(data)=>{
   let req = {"zodiac":{"id":data.zodiacId},
   "date":data.date,
   "vehicleExpenditure":data.vehicle_expenditure,
   "untoward":data.untoward,
   "travel":data.travel,
   "summary":data.summary,
   "remedy":data.solution,
   "marriageAndMarriedLife":data.marriage_status,
   "luckyNumber":data.lucky_number,
   "luckyGem":data.lucky_gem,
   "luckyDay":data.lucky_day,
   "loveRelation":data.love_and_relation,
   "loss":data.loss,
   "loan":data.loan,
   "hobbies":data.hobbies,
   "health":data.health,
   "familyAndRelation":data.family_and_relation,
   "characterQuality":data.character_quality,
   "career":data.career,
   "business":data.business,
   "auspiciousWork":data.auspicious_work}
   return req;
}

export const Weekly=(data)=>{
   let req = {"zodiac":{"id":data.zodiacId},
   "startDate":data.startdate,
   "endDate":data.endDate,
   "vehicleExpenditure":data.vehicle_expenditure,
   "untoward":data.untoward,
   "travel":data.travel,
   "summary":data.summary,
   "remedy":data.solution,
   "marriageAndMarriedLife":data.marriage_status,
   "luckyNumber":data.lucky_number,
   "luckyGem":data.lucky_gem,
   "luckyDay":data.lucky_day,
   "loveRelation":data.love_and_relation,
   "loss":data.loss,
   "loan":data.loan,
   "hobbies":data.hobbies,
   "health":data.health,
   "familyAndRelation":data.family_and_relation,
   "characterQuality":data.character_quality,
   "career":data.career,
   "business":data.business,
   "auspiciousWork":data.auspicious_work}
   return req;
}

export const Monthly=(data)=>{

   var foo =   data.monthDate;
   var arr = foo.split("-");
  var year = arr[0];
  
  var months = ["JANUARY", "FEBRUARY", "MARCH", "APRIL", "MAY", "JUNE", "JULY", 
  "AUGUST", "SEPTEMBER", "OCTOBER", "NOVEMBER", "DECEMBER"];
  var month1=months[arr[1]-1];// month name 

   let req = {"zodiac":{"id":data.zodiacId},
   "month":month1,
   "year":year,
   "vehicleExpenditure":data.vehicle_expenditure,
   "untoward":data.untoward,
   "travel":data.travel,
   "summary":data.summary,
   "remedy":data.solution,
   "marriageAndMarriedLife":data.marriage_status,
   "luckyNumber":data.lucky_number,
   "luckyGem":data.lucky_gem,
   "luckyDay":data.lucky_day,
   "loveRelation":data.love_and_relation,
   "loss":data.loss,
   "loan":data.loan,
   "hobbies":data.hobbies,
   "health":data.health,
   "familyAndRelation":data.family_and_relation,
   "characterQuality":data.character_quality,
   "career":data.career,
   "business":data.business,
   "auspiciousWork":data.auspicious_work}
   return req;
}


export const Yearly=(data)=>{
   let req = {"zodiac":{"id":data.zodiacId},
   "year":data.yearDate,
   "vehicleExpenditure":data.vehicle_expenditure,
   "untoward":data.untoward,
   "travel":data.travel,
   "summary":data.summary,
   "remedy":data.solution,
   "marriageAndMarriedLife":data.marriage_status,
   "luckyNumber":data.lucky_number,
   "luckyGem":data.lucky_gem,
   "luckyDay":data.lucky_day,
   "loveRelation":data.love_and_relation,
   "loss":data.loss,
   "loan":data.loan,
   "hobbies":data.hobbies,
   "health":data.health,
   "familyAndRelation":data.family_and_relation,
   "characterQuality":data.character_quality,
   "career":data.career,
   "business":data.business,
   "auspiciousWork":data.auspicious_work}
   return req;
}